module.exports = "<span [innerHTML]=\"counter\"></span>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/misc/auto-skip-timer/auto-skip-timer.component.html
// module id = 8Byu
// module chunks = 1